import { Service } from '@/services/helpers/ServiceHelper'

type UrlShortener = 'always' | 'never' | 'ask'

export const usePreferencesStore = defineStore('preferences', () => {
  const apiUrl = useLocalStorage('apiUrl', import.meta.env.VITE_API_ENDPOINT, { writeDefaults: false })
  // Keeps axios in sync with every write path: local saves AND cross-tab storage syncs.
  watch(apiUrl, (value) => {
    Service.$axiosInstance.defaults.baseURL = value || import.meta.env.VITE_API_ENDPOINT
  }, { immediate: true })
  // Web sets it from the drawer width via ResizeObserver. Mobile resets it to false on mount.
  const drawerCollapsed = ref(true)
  const drawerPinned = useLocalStorage('drawerPinned', false)
  // Renamed from the old 'urlShortenerPreference' key so nobody inherits its legacy '' sentinel.
  const urlShortener = useLocalStorage<UrlShortener>('urlShortener', 'ask', { writeDefaults: false })
  const alwaysShowReceivedDelivered = useLocalStorage('alwaysShowReceivedDelivered', false)
  const nameDetection = useLocalStorage('show-caller-id-suggestions', true)
  return {
    apiUrl,
    drawerCollapsed,
    drawerPinned,
    urlShortener,
    alwaysShowReceivedDelivered,
    nameDetection
  }
})
